import React from 'react';
import SvgIcon, { IconProps, getColor } from './SvgIcon';

export default function UnderlineIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke={getColor(props.color)} d="M5.5 4v8.5a6.5 6.5 0 1 0 13 0V4" />
      <path stroke={getColor(props.color)} strokeLinecap="round" strokeWidth="1.5" d="M3 22h18" />
    </SvgIcon>
  );
}
